import React, {useEffect, useState} from "react";
import useFetch, {CachePolicies} from "use-http";
import {Modal} from "antd";
import Lightbox from "react-image-lightbox";
import styles from "./UIChatModalViewFile.module.scss";
import download_file from "./images/download.png";
import {sendStatus, Service} from "./ChatConstants";
import _ from "lodash";
import CenterConfirmModal from "src/components/shared/Modal/CenterConfirmModal";
import {useTranslation} from "react-i18next";
import ReactPlayer from "react-player";

function UIChatModalViewFile(props: any) {
  const {
    isOpen,
    data,
    handleCloseViewImage,
    currentUserId,
    setNewMessageList,
    setMessageList,
    setStorageMessageList,
    setPreviewFile,
    deleteListMessage,
  } = props;
  const { t } = useTranslation();
  // const images = data?.objMsg?.messageURLlocal
  //   ? data?.objMsg?.messageURLlocal?.imageDetails
  //   : data?.objMsg?.messageDetails?.imageDetails || data?.objMsg?.messageDetails?.fileDetails;
  const images = data?.objMsg?.messageDetails?.imageDetails || data?.objMsg?.messageDetails?.fileDetails;
  const [photoIndex, setPhotoIndex]: any = useState(data?.index);
  const [showDeleteModal, setShowDeleteModal]: any = useState(false);
  const fileServiceDownloadURLNon =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile";
  const fileServiceDownloadURL =
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + "/downloadFile?fileId=";
  const mainSrc =
    data?.status === "old"
      ? fileServiceDownloadURL + data?.fileId + "&size=1024"
      : fileServiceDownloadURL + data?.fileId;
  const apiMoveFileToTrash = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_FILE_SERVER + Service.FileSreviceMoveFileToTrash,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  const apiSaveMessageImage = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_CHAT_SERVICE + Service.ChatSaveMessageImage,
    {
      method: "post",
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );
  console.log('images::', images);
  console.log('data::', data);
  const handleCheckDelete = async (fileDetails: any, messageId: any, fileId: any) => {
    let fileDetail = data?.fileType === "video" ? [] :fileDetails?.filter((item: any) => item.id !== fileId);
    let localDetail: any;
    if (data?.fileType !== "video" && data?.objMsg?.messageURLlocal) {
      localDetail = {
        imageDetails: data?.objMsg?.messageURLlocal?.imageDetails?.filter(
          (item: any, index: any) => index !== data?.index
        )
      };
    }
    const msgBody = {
      groupId: data?.objMsg?.groupId,
      messageId: messageId,
      messageText: "",
      messageDetails: data?.fileType === "video" ? { videoDetails: [] }: { imageDetails: fileDetail },
    };
    let responseData: any;
    try {
      console.log("msgBody::", msgBody);
      responseData = await apiSaveMessageImage.post(msgBody);
      if (localDetail) {
        setNewMessageList((prevState: any) =>
          _.uniqBy(
            prevState.map((item: any) =>
              item?.messageId === data?.objMsg?.messageId
                ? Object.assign({}, item, {
                  messageURLlocal: localDetail,
                })
                : item
            ),
            "messageId"
          )
        );
        setMessageList((prevState: any) =>
          _.uniqBy(
            prevState.map((item: any) =>
              item?.messageId === data?.objMsg?.messageId
                ? Object.assign({}, item, {
                  messageURLlocal: localDetail,
                })
                : item
            ),
            "messageId"
          )
        );
        setStorageMessageList((prevState: any) =>
          _.uniqBy(
            prevState.map((item: any) =>
              item?.messageId === data?.objMsg?.messageId
                ? Object.assign({}, item, {
                  messageURLlocal: localDetail,
                })
                : item
            ),
            "messageId"
          )
        );
      }
    } catch (e) {
      console.warn("Error hendleSaveMessageImage : ", e);
    }
  };

  const clickDelete = () => {
    setShowDeleteModal(true);
  };

  async function deleteFileConfirm() {
    await apiMoveFileToTrash.post({
      fileId: data?.fileType === "video" ? data?.fileId : images[photoIndex]?.id,
      type: data?.fileType === "video" ? data?.fileType : images[photoIndex]?.fileType,
    });
    let fileDetails = data?.fileType === "video" ? data?.objMsg?.messageDetails?.videoDetails : data?.objMsg?.messageDetails?.imageDetails;
    const messageId = data?.objMsg?.messageId;
    await handleCheckDelete(fileDetails, messageId, images[photoIndex]?.id);
    if (data?.objMsg?.messageDetails?.imageDetails?.length === 1) {
      const msgBody = {
        groupId: data?.objMsg?.groupId,
        messageId: data?.objMsg?.messageId,
        userId: data?.objMsg?.userId,
        transactionType: sendStatus.Delete.toLowerCase(),
      };
      await deleteListMessage([msgBody]);
      setPreviewFile(false);
    }else{
      setPreviewFile(false);
    }
  }

  useEffect(() => {
    console.log("images", images, photoIndex)
  }, [images, photoIndex])

  useEffect(() => {
    // console.log("mainSrc", data?.status === "old" && images.photoIndex?.id ? fileServiceDownloadURL + images.photoIndex?.id + "&size=1024" : URL.createObjectURL(images.photoIndex));
  }, [isOpen])

  return (
    <>
      {data?.fileType === "image" && (
        <Lightbox
          // mainSrc={"https://mocha.centerapp.io/FileCacheService/4e9e4fb6-947b-41d7-81cd-48e49ed6eddc_300.jpg"}
          // nextSrc={"https://mocha.centerapp.io/FileCacheService/4e9e4fb6-947b-41d7-81cd-48e49ed6eddc_300.jpg"}
          // prevSrc={"https://mocha.centerapp.io/FileCacheService/4e9e4fb6-947b-41d7-81cd-48e49ed6eddc_300.jpg"}
          wrapperClassName={"lightboxOverride"}
          imageTitle={images[photoIndex]?.id ? images[photoIndex]?.fileName : images[photoIndex]?.name}
          onCloseRequest={() => {
            handleCloseViewImage();
          }}
          mainSrc={data?.status === "old" && images[photoIndex]?.id ? fileServiceDownloadURL + images[photoIndex]?.id + "&size=1024" : URL.createObjectURL(images[photoIndex])}
          nextSrc={data?.status === "old" && images[photoIndex]?.id ? fileServiceDownloadURL + images[(photoIndex + 1) % images.length]?.id + "&size=1024" : URL.createObjectURL(images[photoIndex])}
          prevSrc={data?.status === "old" && images[photoIndex]?.id ? fileServiceDownloadURL + images[(photoIndex + images.length - 1) % images.length]?.id + "&size=1024" : URL.createObjectURL(images[photoIndex])}
          onMovePrevRequest={() => {
            var aLink = document.getElementById("linkDowload");
            var indexImg = (photoIndex + images?.length - 1) % images?.length;
            if (aLink) {
              //@ts-ignore        
              aLink.href = fileServiceDownloadURL + images[indexImg]?.id;
            }
            setPhotoIndex((prevState: any) => (prevState + images?.length - 1) % images?.length);
          }}
          onMoveNextRequest={() => {
            var aLink = document.getElementById("linkDowload");
            var indexImg = (photoIndex + images.length - 1) % images.length;
            if (aLink) {
              //@ts-ignore
              aLink.href = fileServiceDownloadURL + images[indexImg]?.id;
            }
            setPhotoIndex((prevState: any) => (prevState + images?.length + 1) % images?.length);
          }}
          onAfterOpen={() => {
            if (!data || (data?.status !== "new")) {
              document?.querySelector('.ril__outerAnimating')?.insertAdjacentHTML(
                'afterend',
                `<div 
                  class="ril__toolbar_bottom" 
                  style="
                    position: fixed;
                    bottom: 0;
                    color: white;
                    width: 100%;
                    padding: 10px;
                    background-color: #00000052;
                    display: flex; "
                >
                <div style="width: 100%; display: flex;" >
                  <div style="width: 50%" >
                    <div id="deleteImage" style="float: left; cursor: pointer; display: ${currentUserId === data?.objMsg?.userId? "block":"none"}; " >
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash" class="svg-inline--fa fa-trash fa-w-14 font-awesome" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="cursor: pointer; color: white;width: 16px;height: 16px;margin: auto;"><path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path></svg>
                    </div>
                  </div>
                  <div style="width: 50%"  >
                    <div style="float: right; cursor: pointer; dis">
                      <a id="linkDowload" href=${fileServiceDownloadURL + images[photoIndex]?.id + "&size=1024"} rel="noopener noreferrer" download>
                        <img src="${download_file}" style="width: 20px;"></img>
                      </a>
                    </div>
                  </div>
                </div>
              </div>`
              );
              var delBtn = document.getElementById("deleteImage");
              if (delBtn) {
                //@ts-ignore
                delBtn.onclick = clickDelete;
              }
            }
          }}
        />
      )}

      <CenterConfirmModal
        cancelText={t("Cancel")}
        confirmText={t("Ok")}
        text={t("Are you sure to delete message?")}
        visible={showDeleteModal}
        onCancel={() => {
          setShowDeleteModal(false);
        }}
        onConfirm={() => {
          deleteFileConfirm();
          setShowDeleteModal(false);
        }}
      ></CenterConfirmModal>

      {data?.fileType === "video" && (
        <>
          <Modal
            centered
            className={styles.modalOveride}
            visible={isOpen}
            footer={null}
            onCancel={() => handleCloseViewImage()}
          >
            {/* <div className={styles.topBarMedia} >
              <div style={{ display: "flex", width: "100%" }}>
                <div
                  className={styles.fileNameMedia}
                  style={{
                    display: "block",
                    color: "white",
                    width: "calc(100% - 50px)",
                  }}
                >
                  {props?.data?.fileName}
                </div>
                <div
                  onClick={() => {
                    handleCloseViewImage();
                  }}
                >
                  <FontAwesomeIcon
                    className="font-awesome"
                    icon={faTimes}
                    style={{
                      color: "rgb(193 192 192)",
                      width: "16px",
                      height: "16px",
                      margin: "auto",
                      cursor: "pointer"
                    }}
                  />
                </div>
              </div>
            </div> */}

            {/* <div className={styles.videoViewerUpload} > */}
              <div style={{ width: "100%" }}>
                {/* <p>{props?.data?.fileName}</p> */}
                <ReactPlayer
                  // onReady={videAudioOnReady}
                  controls={true}
                  className={styles.reactPlayer}
                  url={
                    props?.data?.localURL ||
                    fileServiceDownloadURL +
                    data?.fileId +
                    "&amp;onTrashReqIgnore=false&amp;"
                  }

                />
              </div>
              
            {/* </div> */}

            <div className={styles.bottomBarMedia} >
              <div style={{ display: "flex", width: "100%", marginTop: "12px" }}>
                <div style={{ width: "50%" }}>
                  {currentUserId === data?.objMsg?.userId && (
                    <div id="deleteImage" style={{ float: "left", cursor: "pointer" }} onClick={clickDelete}>
                      <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="trash" className="svg-inline--fa fa-trash fa-w-14 font-awesome" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style={{ cursor: "pointer", color: "white", width: "16px", height: "16px", margin: "auto" }}><path fill="currentColor" d="M432 32H312l-9.4-18.7A24 24 0 0 0 281.1 0H166.8a23.72 23.72 0 0 0-21.4 13.3L136 32H16A16 16 0 0 0 0 48v32a16 16 0 0 0 16 16h416a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zM53.2 467a48 48 0 0 0 47.9 45h245.8a48 48 0 0 0 47.9-45L416 128H32z"></path></svg>
                    </div>
                  )}
                </div>
                <div style={{ width: "50%" }}>
                  <div style={{ float: "right", cursor: "pointer" }}>
                    <a id="linkDowload" href={fileServiceDownloadURL + data?.fileId} rel="noopener noreferrer" download>
                      <img src={download_file} style={{ width: "20px" }} alt=""></img>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>

        </>
      )}
    </>
  );
}

export default UIChatModalViewFile;
